module.exports = __webpack_public_path__ + "img/15.c673d8fb.png";